import { Tooltip } from 'react-tooltip';

interface HoverableSpanProps {
  tooltipId?: string;
  tooltipContent?: React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
}

const HoverableSpan = ({ tooltipId, tooltipContent, children, disabled }: HoverableSpanProps) => {
  return (
    <>
      <span className={`hoverable-span ${disabled ? 'disabled' : ''}`} data-tooltip-id={tooltipId}>
        {children}
      </span>

      {tooltipId && tooltipContent && (
        <Tooltip id={tooltipId} place="top" positionStrategy="fixed" className="body-tooltip">
          {tooltipContent}
        </Tooltip>
      )}
    </>
  );
};

export default HoverableSpan;
